import React from "react";
import styled from 'styled-components';

const NextBtn = ({ onClick }) => {
  return (
    <Container className="next-btn">
      <div className="btn-wrap" onClick={() => onClick('up')}>
        <img className="next-img" src="https://file.wogoo.com/image/activity/active_205/next-btn@2x.png" alt=""/>
        <span className="next-text">上一页</span>
      </div>
      <div className="btn-wrap" onClick={() => onClick('down')}>
        <img className="next-img next-img1" src="https://file.wogoo.com/image/activity/active_205/next-btn@2x.png" alt=""/>
        <span className="next-text">下一页</span>
      </div>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: 0;
  bottom: 36px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;
  .btn-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 60px;
  }
  .next-img {
    width: 20px;
    height: 20px;
    margin-bottom: 12px;
  }
  .next-img1 {
    transform: rotate(180deg);
  }
  .next-text {
    font-weight: 600;
    font-size: 13px;
    color: #360606;
    line-height: 17px;
  }
`;

export default NextBtn;


// WEBPACK FOOTER //
// ./src/views/activity_205/next.js